// extracted by mini-css-extract-plugin
export default {"navLinks":"styles_navLinks__cVs9O","active":"styles_active__r19f8"};